class ObjectHelper {
	/**
	 * Checks whether object is empty (has no keys).
	 * @param {Object} object
	 * @return {boolean}
	 */
	static isEmpty(object) {
		return object === null || Object.keys(object).length === 0;
	}

	/**
	 * Adds values as array elemen inside the object property. Example:
	 * ```
	 * const obj = {};
	 * ObjectHelper.addAsArrayElement(obj, 'a', 1);
	 * ObjectHelper.addAsArrayElement(obj, 'a', 2);
	 * ObjectHelper.addAsArrayElement(obj, 'b', 1);
	 *
	 * // now $obj is {
	 * //		a: [1, 2],
	 * //		b: [1]
	 * //	}
	 * ```
	 * @param obj
	 * @param key
	 * @param value
	 */
	static addAsArrayElement(obj, key, value) {
		let selectedObj = obj[key];

		if (!Array.isArray(selectedObj)) {
			selectedObj = [];
			obj[key] = selectedObj;
		}

		selectedObj.push(value);
	}
}

export default ObjectHelper;
